import clsx from "clsx"
import { motion } from "motion/react"

function Page({ children, className }) {
  return (
    <motion.div
      className={clsx("w-full", className)}
      initial={{ opacity: 0, x: -20, scale: 0.97 }}
      animate={{ opacity: 1, x: 0, scale: 1 }}
      exit={{ opacity: 0, x: 20, scale: 0.97 }}
      transition={{ duration: 0.2, ease: "easeInOut" }}
    >
      {children}
    </motion.div>
  )
}

export { Page }
